import { useEffect, useRef, useState } from 'react';

const useMultiIntersectionObserver = (threshold = 0.3) => {
  const elementsRef = useRef([]);
  const [visibleElements, setVisibleElements] = useState([]);
  const [isScrolling, setIsScrolling] = useState(false);
  const observerRef = useRef(null);

  if (window.innerWidth < 850) {
    threshold = 0.2;
  }

  const resetAndObserve = (currentElements) => {
    setVisibleElements([]);
    currentElements.forEach((element) => {
      if (element && observerRef.current) {
        observerRef.current.observe(element);
      }
    });
  };

  useEffect(() => {
    const currentElements = elementsRef.current;
    observerRef.current = new IntersectionObserver(
      (entries) => {
        console.log(isScrolling);
        if (!isScrolling) {
          entries.forEach((entry) => {
            const index = currentElements.indexOf(entry.target);
            if (entry.isIntersecting) {
              setVisibleElements((prev) => {
                if (!prev.includes(entry.target)) {
                  return [...prev, entry.target];
                }
                return prev;
              });
            } else if (index === 2 || index === 9
              || index === 16 || index === 26) {
              setVisibleElements((prev) =>
                prev.filter((element) => element !== entry.target)
              );
            }
          });
        }
      },
      { threshold }
    );

    currentElements.forEach((element) => {
      if (element) observerRef.current.observe(element);
    });

    return () => {
      currentElements.forEach((element) => {
        if (element && observerRef.current) {
          observerRef.current.unobserve(element);
        }
      });
    };
  }, [threshold, isScrolling]);

  useEffect(() => {
    const handlePopState = () => {

      const currentElements = elementsRef.current;

      setTimeout(() => {
        currentElements.forEach((element) => {
          if (element && observerRef.current) {
            observerRef.current.unobserve(element);
          }
        });

        resetAndObserve(currentElements);
      }, 0);


    };

    window.addEventListener('popstate', handlePopState);

    const originalPushState = window.history.pushState;
    window.history.pushState = function (...args) {
      originalPushState.apply(this, args);
      if (window.location.pathname === '/bowler') {
        handlePopState();
        window.scrollTo(0, 0);
      }
    };

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return [visibleElements, elementsRef, setIsScrolling];
};

export default useMultiIntersectionObserver;
